import React from "react"
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

import bannerimage from '../../../assets/images/banner-image.png';

import toyotaicon from '../../../assets/images/toyota-icon.png';
import hyundaiicon from '../../../assets/images/hyundai-icon.png';
import suzukiicon from '../../../assets/images/suzuki-icon.png';
import kiaicon from '../../../assets/images/kia-icon.png';


const BannerContent = () => {
    return (
        <div className="banner-content">
        <Container>
            <Row>
                <Col md={12}>
                    <h2>We Make your Drive Memorable</h2>
                    <h1>Quickly you need <br/>to rent a car?</h1>
                    <span className="toyota-icon"><img src={toyotaicon} alt="toyota" /></span>
                    <span className="hyundai-icon"><img src={hyundaiicon} alt="hyundai" /></span>
                    <span className="suzuki-icon"><img src={suzukiicon} alt="suzuki" /></span>
                    <span className="kia-icon"><img src={kiaicon} alt="kia" /></span>
                    <img src={bannerimage}  alt="Banner" />
                </Col>
            </Row>
        </Container>   
    </div>
           
    );
  }
  
  export default BannerContent;